/**
 * TODO: Nothing is done for tag.
 * Image is over floating
 */

import React from "react";
import { Field, change } from "redux-form";
import { Form, FormGroup, Button, Label } from "reactstrap";
/** Local Components */
import DatePicker from "react-datepicker";
import { Input } from "../../../core";
import { TagSelect } from "../../../core/form/tagSelect";
import {
  required,
  fileName,
  validateSymbols
} from "../../../helper/validation";

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength90 = maxLength(90);

const CustomInput = ({ value, onClick }) => (
  <div className="expirationDateWrapper">
    <input onClick={onClick} value={value} />
    <i className="expirationDateWrapper__calendar fa fa-calendar-alt" />
  </div>
);

class SingleContentUploadForm extends React.Component {
  componentDidMount = () => {
    const { props } = this;
    this.props.dispatch(
      change("Contents", `media-${props.id}-name`, props.item.name)
    );
    this.props.dispatch(
      change("Contents", `media-${props.id}-tag`, props.item.tags)
    );
    this.props.dispatch(
      change("Contents", `media-${props.id}-sponser`, props.item.tags)
    );
    this.props.dispatch(
      change("Contents", `media-${props.id}-expiration_date`, undefined)
    );
  };

  handleTagChange = (tags, type) => {
    const files = this.props.data.map(item => {
      const temp = item;
      if (item.id === this.props.id) {
        temp[type] = tags;
        return temp;
      }
      return temp;
    });
    this.props.dispatch(change("ContentUploadForms", `Files`, files));
  };

  handleInputChange = input => {
    const files = this.props.data.map(item => {
      if (item.id === this.props.id) {
        const temp = item;
        temp.name = input;
        return temp;
      }
      return item;
    });
    this.props.dispatch(change("ContentUploadForms", `Files`, files));
  };

  handleDisplayNameChange = input => {
    const files = this.props.data.map(item => {
      if (item.id === this.props.id) {
        const temp = item;
        temp.display_name = input;
        return temp;
      }
      return item;
    });
    this.props.dispatch(change("ContentUploadForms", `Files`, files));
  };

  handleExpirationDateChange = input => {
    const files = this.props.data.map(item => {
      if (item.id === this.props.id) {
        const temp = item;
        temp.expiration_date = input;
        return temp;
      }
      return item;
    });
    this.props.dispatch(change("ContentUploadForms", `Files`, files));
  };

  getIconForFile = item => {
    if (item.type == "Video") {
      return (
        <img
          src={require("../../../assets/images/play-button.png")}
          className="img-fluid "
        />
      );
    } else if (item.file.type == "audio/ogg") {
      return (
        <img
          src={require("../../../assets/images/music-player.png")}
          className="img-fluid "
        />
      );
    } else {
      return <img src={item.url} alt="file" className="float-center" />;
    }
  };

  render() {
    const { props } = this;

    return (
      <div className="upload-content rounded">
        <Form inline>
          <div className="media d-flex justify-content-center flex-wrap">
            {this.getIconForFile(props.item)}
          </div>
          <FormGroup className="mb-2 tagup flex-fill">
            <Field
              type="text"
              component={Input}
              name={`media-${props.id}-name`}
              value={props.item.name}
              validate={[required, fileName, maxLength90, validateSymbols]}
              handleInputChange={this.handleInputChange}
              id="mediaName"
              label="Name"
              placeholder="Content Name"
              class="upload-content-input"
            />
          </FormGroup>
          <FormGroup className="mb-2 tagup flex-fill">
            <Field
              type="text"
              component={Input}
              name={`display-${props.id}-name`}
              value={props.item.name}
              validate={[maxLength90, validateSymbols]}
              handleInputChange={this.handleDisplayNameChange}
              id="mediaName"
              label="Display Name"
              placeholder="Display Name"
            />
          </FormGroup>
          <FormGroup className="mb-2 tagup flex-fill">
            <Label>Tag</Label>
            <div className="autofilltag">
              <Field
                component={TagSelect}
                name={`media-${props.id}-tag`}
                label="Tag"
                className="header-tag-search form-group--borderless"
                onChange={e => this.handleTagChange(e, "tags")}
                options={this.props.ContentTag.map(i => ({
                  value: i,
                  label: i
                }))}
                handleInputChange={this.props.handleInputChange}
              />
            </div>
          </FormGroup>
          <FormGroup className="mb-2 tagup flex-fill">
            <Label>Sponsor</Label>
            <div className="autofilltag">
              <Field
                component={TagSelect}
                name={`media-${props.id}-sponser`}
                label="Sponser"
                className="header-tag-search form-group--borderless"
                onChange={e => this.handleTagChange(e, "sponsers")}
                options={this.props.SponserTag.map(i => ({
                  value: i,
                  label: i
                }))}
                placeholder="Add Sponsors"
              />
            </div>
          </FormGroup>
          <FormGroup>
            <Field
              hidden
              component="input"
              name={`media-${props.id}-bulk-tag`}
            />
          </FormGroup>
          <FormGroup className="mb-2 tagup">
            <Label>Expiration Date</Label>
            <DatePicker
              selected={props.item.expiration_date}
              onChange={this.handleExpirationDateChange}
              minDate={new Date()}
              customInput={<CustomInput />}
            />
          </FormGroup>
          <Button
            outline
            color="primary"
            onClick={() =>
              this.props.handleRemove(this.props.files, this.props.item)
            }
            className="d-flex ml-auto remove mt-2"
          >
            Remove
          </Button>
        </Form>
      </div>
    );
  }
}

const GenerateForms = ({
  data,
  handleRemove,
  ContentTag,
  filteredTags,
  handleInputChange,
  ...rest
}) =>
  data.map(item => (
    <SingleContentUploadForm
      handleRemove={handleRemove}
      item={item}
      id={item.id}
      key={item.id}
      data={data}
      ContentTag={ContentTag}
      filteredTags={filteredTags}
      handleInputChange={handleInputChange}
      {...rest}
    />
  ));

export default GenerateForms;
